import React, { FC } from "react";
import { TablePagination, TableRow } from "@mui/material";
import { TablePaginationActions } from "../index";
import { TableFooterStyled } from "./TableFooter.style";
import { ITableFooterProps, TRowsPerPageOptions } from "./TableFooter.types";

const TableFooter: FC<ITableFooterProps> = ({
  colSpan,
  count,
  handleChangePage,
  page,
  handleChangeRowsPerPage,
  rowsPerPage,
  draggable = false,
}) => {
  let rowsPerPageOptions: TRowsPerPageOptions[] = [5, 10, 25, 50];
  if (draggable) rowsPerPageOptions.push({ label: "All", value: -1 });
  return (
    <TableFooterStyled>
      <TableRow>
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          colSpan={colSpan}
          count={count}
          rowsPerPage={rowsPerPage}
          page={count > 0 ? page - 1 : 0}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: false,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          //@ts-ignore
          ActionsComponent={() => (
            <TablePaginationActions
              count={count}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={handleChangePage}
            />
          )}
        />
      </TableRow>
    </TableFooterStyled>
  );
};

export default TableFooter;
